(function(Namespace) {
	var ScreenerUtility = function() {
		this._Setup();
	};

	ScreenerUtility.CreateInstance = function() {
		return new Namespace.ScreenerUtility();
	};

	ScreenerUtility.IsValidSortDirection = function(iValue) {
		if (!iValue && iValue != 0) {
			return false;
		}

		var bIsValid = false;

		for (var key in Namespace.ScreenerUtility.SORT_DIRECTION) {
			if (iValue === Namespace.ScreenerUtility.SORT_DIRECTION[key]) {
				bIsValid = true;
				break;
			}
		}

		return bIsValid;
	};

	ScreenerUtility.IsValidOperator = function(iValue) {
		if (!iValue && iValue != 0) {
			return false;
		}

		var bIsValid = false;

		for (var key in Namespace.ScreenerUtility.OPERATORS) {
			if (iValue === Namespace.ScreenerUtility.OPERATORS[key]) {
				bIsValid = true;
				break;
			}
		}

		return bIsValid;
	};

	ScreenerUtility.IsValidArgOrValueOperator = function(iValue) {
		if (!iValue && iValue != 0) {
			return false;
		}

		var bIsValid = false;

		for (var key in Namespace.ScreenerUtility.ARGS_OPERATORS) {
			if (iValue === Namespace.ScreenerUtility.ARGS_OPERATORS[key]) {
				bIsValid = true;
				break;
			}
		}

		return bIsValid;
	};

	/*
	*
	* [Start] Operator Constants
	*
	*/

	ScreenerUtility.OPERATORS = {
		Equals: 0,
		GreaterThanOrEqualTo: 1,
		GreaterThan: 2,
		LessThanOrEqualTo: 3,
		Like: 4,
		LessThan: 5,
		NotEqualTo: 6,
		NotLike: 7
	};

	ScreenerUtility.ARGS_OPERATORS = {
		AND: 0,
		OR: 1
	};

	ScreenerUtility.VALUE_OPERATORS = {
		AND: 0,
		OR: 1
	};

	ScreenerUtility.SORT_DIRECTION = {
		Ascending: 0,
		Descending: 1
	};

	/*
	*
	* [Start] Operator Constants
	*
	*/

	// setup fn as prototype
	ScreenerUtility.fn = ScreenerUtility.prototype;

	ScreenerUtility.fn._Setup = function() {
		this._Inputs = null;
		this._PreSceenURL = "~/API/PreScreen";
		this._SceenURL = "~/API/Screen";

		this._SaveScreenURL = "~/API/SaveScreen";
		this._DeleteScreenURL = "~/API/DeleteScreen";
		this._SetDefaultScreenURL = "~/API/SetDefaultScreen";

		this._AdditionalAJAXData = {};

		// Setup Listener objects. These will each get a special key. That way they can be removed if need be.
		this._BeforeSendDataListeners = {};
		this._SendDataReturnCompletedListeners = {};
		this._SendDataReturnSuccessListeners = {};
		this._SendDataReturnFailureListeners = {};

		// Setup prescreen listeners
		this._BeforePreScreenListeners = {};
		this._PreScreenCompletedListeners = {};
		this._PreScreenSuccessListeners = {};
		this._PreScreenFailureListeners = {};

		// Setup save screen listeners
		this._BeforeSaveScreenListeners = {};
		this._SaveScreenCompleteListeners = {};
		this._SaveScreenSuccessListeners = {};
		this._SaveScreenFailureListeners = {};

		// Setup delete save screen listeners
		this._BeforeDeleteScreenListeners = {};
		this._DeleteScreenCompleteListeners = {};
		this._DeleteScreenSuccessListeners = {};
		this._DeleteScreenFailureListeners = {};

		// Setup set default screen listeners
		this._BeforeSetDefaultScreenListeners = {};
		this._SetDefaultScreenCompleteListeners = {};
		this._SetDefaultScreenSuccessListeners = {};
		this._SetDefaultScreenFailureListeners = {};
	};

	ScreenerUtility.fn.SetInputs = function(Inputs) {
		if (Inputs && (Inputs._Type == "Inputs" || Inputs._Type == "ScreenInputs")) {
			this._Inputs = Inputs;
		}
		else {
			throw ("Error occured in ScreenerUtility.SetInputs(Inputs): Inputs can not be null and must be of type ScreenerUtility.Inputs or ScreenerUtility.ScreenInputs. Please check our input and try again.");
		}

		return this;
	};

	ScreenerUtility.fn.SetPreScreenURL = function(sURL) {
		this._PreSceenURL = sURL;

		return this;
	};

	ScreenerUtility.fn.SetScreenURL = function(sURL) {
		this._SceenURL = sURL;

		return this;
	};

	ScreenerUtility.fn.SetSaveScreenURL = function(sURL) {
		this._SaveScreenURL = sURL;

		return this;
	};

	ScreenerUtility.fn.SetDeleteSaveScreenURL = function(sURL) {
		this._DeleteScreenURL = sURL;

		return this;
	};

	ScreenerUtility.fn.SetDefaultScreenURL = function(sURL) {
		this._SetDefaultScreenURL = sURL;

		return this;
	};

	ScreenerUtility.fn.SetAdditionalAJAXData = function(objData) {
		$.extend(true, this._AdditionalAJAXData, objData);

		return this;
	};

	ScreenerUtility.fn.GetInputs = function(bJustData) {
		if (bJustData) {
			return this._Inputs.GetData();
		}
		else {
			return this._Inputs;
		}
	};

	ScreenerUtility.fn.GetSendDataURL = function() {
		return this._SendDataURL;
	};

	ScreenerUtility.fn.GetAdditionalAJAXData = function() {
		return this._AdditionalAJAXData;
	};

	ScreenerUtility.fn.DoScreen = function(bAllowAbortion) {
		// check if we are actually allowed to send the inputs
		if (this._Inputs._Type != "ScreenInputs") {
			throw ("Cannot do Screen call because inputs are not of type ScreenInputs. Please check the set inputs and try again.");
		}

		for (var key in this._BeforeSendDataListeners) {
			this._BeforeSendDataListeners[key]();
		}

		var context = this;

		var DataToSend = {
			Inputs: JSON.stringify(this.GetInputs(true))
		};

		// add additional data
		$.extend(true, DataToSend, this._AdditionalAJAXData);

		// only abort if we are allowed to.
		if (bAllowAbortion) {
			try {
				this.SendDataXHR.abort();
			}
			catch (e) { }
		}

		this.SendDataXHR = $.ajax({
			type: "POST",
			data: DataToSend,
			dataType: "json",
			traditional: true,
			url: context._SceenURL.resolveUrl(),
			complete: function(jqXHR, textStatus) {
				context._SendDataComplete(jqXHR, textStatus);
			},
			success: function(Response, textStatus, jqXHR) {
				context._SendDataSuccess(Response, textStatus, jqXHR);
			},
			error: function(jqXHR, textStatus, errorThrown) {
				context._SendDataFailure(jqXHR, textStatus, errorThrown);
			}
		});

		return this;
	};

	ScreenerUtility.fn.DoPreScreen = function(bAllowAbortion) {
		// check if we are actually allowed to send the inputs
		if (this._Inputs._Type != "Inputs" && this._Inputs._Type != "ScreenInputs") {
			throw ("Cannot do PreScreen call because inputs are not of base type Inputs. Please check the set inputs and try again.");
		}

		for (var key in this._BeforePreScreenListeners) {
			this._BeforePreScreenListeners[key]();
		}

		var context = this;

		var DataToSend = {
			Inputs: JSON.stringify(this.GetInputs(true))
		};

		// add additional data
		$.extend(true, DataToSend, this._AdditionalAJAXData);

		// only abort if we are allowed to.
		if (bAllowAbortion) {
			try {
				this.SendPreScreenXHR.abort();
			}
			catch (e) {

			}
		}

		this.SendPreScreenXHR = $.ajax({
			type: "POST",
			data: DataToSend,
			dataType: "json",
			url: context._PreSceenURL.resolveUrl(),
			complete: function(jqXHR, textStatus) { context._PreScreenComplete(jqXHR, textStatus); },
			success: function(Response, textStatus, jqXHR) { context._PreScreenSuccess(Response, textStatus, jqXHR); },
			error: function(jqXHR, textStatus, errorThrown) { context._PreScreenFailure(jqXHR, textStatus, errorThrown); }
		});

		return this;
	};

	/************************************
	*
	* [Start] Send Data Methods
	*
	************************************/

	ScreenerUtility.fn._SendDataComplete = function(jqXHR, textStatus) {
		for (var key in this._SendDataReturnCompletedListeners) {
			this._SendDataReturnCompletedListeners[key](jqXHR, textStatus);
		}
	};

	ScreenerUtility.fn._SendDataSuccess = function(Response, textStatus, jqXHR) {
		for (var key in this._SendDataReturnSuccessListeners) {
			this._SendDataReturnSuccessListeners[key](Response, textStatus, jqXHR);
		}
	};

	ScreenerUtility.fn._SendDataFailure = function(jqXHR, textStatus, errorThrown) {
		for (var key in this._SendDataReturnFailureListeners) {
			this._SendDataReturnFailureListeners[key](jqXHR, textStatus, errorThrown);
		}
	};

	ScreenerUtility.fn._PreScreenComplete = function(jqXHR, textStatus) {
		for (var key in this._PreScreenCompletedListeners) {
			this._PreScreenCompletedListeners[key](jqXHR, textStatus);
		}
	};

	ScreenerUtility.fn._PreScreenSuccess = function(Response, textStatus, jqXHR) {
		for (var key in this._PreScreenSuccessListeners) {
			this._PreScreenSuccessListeners[key](Response, textStatus, jqXHR);
		}
	};

	ScreenerUtility.fn._PreScreenFailure = function(jqXHR, textStatus, errorThrown) {
		for (var key in this._PreScreenFailureListeners) {
			this._PreScreenFailureListeners[key](jqXHR, textStatus, errorThrown);
		}
	};

	/************************************
	*
	* [End] Send Data Methods
	*
	************************************/

	/************************************
	*
	* [Start] Register And Unregister methods
	*
	************************************/

	/* On/Register methods */
	ScreenerUtility.fn.OnBeforeScreen = function(sKey, fCallback) {
		this._BeforeSendDataListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnScreenComplete = function(sKey, fCallback) {
		this._SendDataReturnCompletedListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnScreenSuccess = function(sKey, fCallback) {
		this._SendDataReturnSuccessListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnScreenFail = function(sKey, fCallback) {
		this._SendDataReturnFailureListeners[sKey] = fCallback;

		return this;
	};

	/* Off/Unregister methods */
	ScreenerUtility.fn.OffBeforeScreen = function(sKey) {
		if (sKey && this._BeforeSendDataListeners[sKey]) {
			delete this._BeforeSendDataListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffScreenComplete = function(sKey) {
		if (sKey && this._SendDataReturnCompletedListeners[sKey]) {
			delete this._SendDataReturnCompletedListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffScreenSuccess = function(sKey) {
		if (sKey && this._SendDataReturnSuccessListeners[sKey]) {
			delete this._SendDataReturnSuccessListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffScreenFail = function(sKey) {
		if (sKey && this._SendDataReturnFailureListeners[sKey]) {
			delete this._SendDataReturnFailureListeners[sKey];
		}

		return this;
	};

	/* {Start} PreScreen Register and unRegister callbacks */

	ScreenerUtility.fn.OnBeforePreScreen = function(sKey, fCallback) {
		this._BeforePreScreenListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnPreScreenComplete = function(sKey, fCallback) {
		this._PreScreenCompletedListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnPreScreenSuccess = function(sKey, fCallback) {
		this._PreScreenSuccessListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnPreScreenFail = function(sKey, fCallback) {
		this._PreScreenFailureListeners[sKey] = fCallback;

		return this;
	};

	/**/
	ScreenerUtility.fn.OffBeforePreScreen = function(sKey) {
		if (sKey && this._BeforePreScreenListeners[sKey]) {
			delete this._BeforePreScreenListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffPreScreenComplete = function(sKey) {
		if (sKey && this._PreScreenCompletedListeners[sKey]) {
			delete this._PreScreenCompletedListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffPreScreenSuccess = function(sKey) {
		if (sKey && this._PreScreenSuccessListeners[sKey]) {
			delete this._PreScreenSuccessListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffPreScreenFail = function(sKey) {
		if (sKey && this._PreScreenFailureListeners[sKey]) {
			delete this._PreScreenFailureListeners[sKey];
		}

		return this;
	};

	/* {End} PreScreen Register and unRegister callbacks */

	/* {Start} Save Screen Register and unRegister callbacks */

	ScreenerUtility.fn.OnBeforeSaveScreen = function(sKey, fCallback) {
		this._BeforeSaveScreenListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnSaveScreenComplete = function(sKey, fCallback) {
		this._SaveScreenCompleteListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnSaveScreenSuccess = function(sKey, fCallback) {
		this._SaveScreenSuccessListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnSaveScreenFail = function(sKey, fCallback) {
		this._SaveScreenFailureListeners[sKey] = fCallback;

		return this;
	};

	/* Unregister */

	ScreenerUtility.fn.OffBeforeSaveScreen = function(sKey) {
		if (sKey && this._BeforeSaveScreenListeners[sKey]) {
			delete this._BeforeSaveScreenListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffSaveScreenComplete = function(sKey) {
		if (sKey && this._SaveScreenCompleteListeners[sKey]) {
			delete this._SaveScreenCompleteListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffSaveScreenSuccess = function(sKey) {
		if (sKey && this._SaveScreenSuccessListeners[sKey]) {
			delete this._SaveScreenSuccessListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffSaveScreenFail = function(sKey) {
		if (sKey && this._SaveScreenFailureListeners[sKey]) {
			delete this._SaveScreenFailureListeners[sKey];
		}

		return this;
	};

	/* {End} Save Screen Register call backs */

	/* {Start} Delete Screen Register and unRegister callbacks */

	ScreenerUtility.fn.OnBeforeDeleteScreen = function(sKey, fCallback) {
		this._BeforeDeleteScreenListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnDeleteScreenComplete = function(sKey, fCallback) {
		this._DeleteScreenCompleteListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnDeleteScreenSuccess = function(sKey, fCallback) {
		this._DeleteScreenSuccessListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnDeleteScreenFail = function(sKey, fCallback) {
		this._DeleteScreenFailureListeners[sKey] = fCallback;

		return this;
	};

	/* Unregister */

	ScreenerUtility.fn.OffBeforeDeleteScreen = function(sKey) {
		if (sKey && this._BeforeDeleteScreenListeners[sKey]) {
			delete this._BeforeDeleteScreenListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffDeleteScreenComplete = function(sKey) {
		if (sKey && this._DeleteScreenCompleteListeners[sKey]) {
			delete this._DeleteScreenCompleteListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffDeleteScreenSuccess = function(sKey) {
		if (sKey && this._DeleteScreenSuccessListeners[sKey]) {
			delete this._DeleteScreenSuccessListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffDeleteScreenFail = function(sKey) {
		if (sKey && this._DeleteScreenFailureListeners[sKey]) {
			delete this._DeleteScreenFailureListeners[sKey];
		}

		return this;
	};

	/* {End} Delete Screen Register call backs */

	/* {Start} Set Default Screen Register and unRegister callbacks */

	ScreenerUtility.fn.OnBeforeSetDefaultScreen = function(sKey, fCallback) {
		this._BeforeSetDefaultScreenListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnSetDefaultScreenComplete = function(sKey, fCallback) {
		this._SetDefaultScreenCompleteListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnSetDefaultScreenSuccess = function(sKey, fCallback) {
		this._SetDefaultScreenSuccessListeners[sKey] = fCallback;

		return this;
	};

	ScreenerUtility.fn.OnSetDefaultScreenFail = function(sKey, fCallback) {
		this._SetDefaultScreenFailureListeners[sKey] = fCallback;

		return this;
	};

	/* Unregister */

	ScreenerUtility.fn.OffBeforeSetDefaultScreen = function(sKey) {
		if (sKey && this._BeforeSetDefaultScreenListeners[sKey]) {
			delete this._BeforeSetDefaultScreenListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffSetDefaultScreenComplete = function(sKey) {
		if (sKey && this._SetDefaultScreenCompleteListeners[sKey]) {
			delete this._SetDefaultScreenCompleteListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffSetDefaultScreenSuccess = function(sKey) {
		if (sKey && this._SetDefaultScreenSuccessListeners[sKey]) {
			delete this._SetDefaultScreenSuccessListeners[sKey];
		}

		return this;
	};

	ScreenerUtility.fn.OffSetDefaultScreenFail = function(sKey) {
		if (sKey && this._SetDefaultScreenFailureListeners[sKey]) {
			delete this._SetDefaultScreenFailureListeners[sKey];
		}

		return this;
	};

	/* {End} Set Default Screen Register call backs */

	/************************************
	*
	* [End] Register And Unregister methods
	*
	************************************/

	ScreenerUtility.fn.DoSaveScreen = function(type, name, description) {
		var context = this;

		this._BeforeSaveScreen();

		var DataToSend = {
			Type: type,
			Name: name,
			Description: description,
			Inputs: JSON.stringify(this.GetInputs(true))
		};

		$.ajax({
			type: "POST",
			data: DataToSend,
			dataType: "json",
			url: this._SaveScreenURL.resolveUrl(),
			complete: function(jqXHR, textStatus) { context._SaveScreenComplete(jqXHR, textStatus); },
			success: function(Response, textStatus, jqXHR) { context._SaveScreenSuccess(Response, textStatus, jqXHR); },
			error: function(jqXHR, textStatus, errorThrown) { context._SaveScreenFailure(jqXHR, textStatus, errorThrown); }
		});
	};

	/************************************
	*
	* [Start] Send Data Methods
	*
	************************************/

	ScreenerUtility.fn._BeforeSaveScreen = function() {
		for (var key in this._BeforeSaveScreenListeners) {
			this._BeforeSaveScreenListeners[key]();
		}
	};

	ScreenerUtility.fn._SaveScreenComplete = function(jqXHR, textStatus) {
		for (var key in this._SaveScreenCompleteListeners) {
			this._SaveScreenCompleteListeners[key](jqXHR, textStatus);
		}
	};

	ScreenerUtility.fn._SaveScreenSuccess = function(Response, textStatus, jqXHR) {
		for (var key in this._SaveScreenSuccessListeners) {
			this._SaveScreenSuccessListeners[key](Response, textStatus, jqXHR);
		}
	};

	ScreenerUtility.fn._SaveScreenFailure = function(jqXHR, textStatus, errorThrown) {
		for (var key in this._SaveScreenFailureListeners) {
			this._SaveScreenFailureListeners[key](jqXHR, textStatus, errorThrown);
		}
	};

	/************************************
	*
	* [End] Send Data Methods
	*
	************************************/

	ScreenerUtility.fn.DoDeleteScreen = function(type, name) {
		var context = this;

		this._BeforeDeleteScreen();

		var DataToSend = {
			Type: type,
			Name: name
		};

		$.ajax({
			type: "POST",
			data: DataToSend,
			dataType: "json",
			url: this._DeleteScreenURL.resolveUrl(),
			complete: function(jqXHR, textStatus) { context._DeleteScreenComplete(jqXHR, textStatus); },
			success: function(Response, textStatus, jqXHR) { context._DeleteScreenSuccess(Response, textStatus, jqXHR); },
			error: function(jqXHR, textStatus, errorThrown) { context._DeleteScreenFailure(jqXHR, textStatus, errorThrown); }
		});
	};

	/************************************
	*
	* [Start] Send Data Methods
	*
	************************************/

	ScreenerUtility.fn._BeforeDeleteScreen = function() {
		for (var key in this._BeforeDeleteScreenListeners) {
			this._BeforeDeleteScreenListeners[key]();
		}
	};

	ScreenerUtility.fn._DeleteScreenComplete = function(jqXHR, textStatus) {
		for (var key in this._DeleteScreenCompleteListeners) {
			this._DeleteScreenCompleteListeners[key](jqXHR, textStatus);
		}
	};

	ScreenerUtility.fn._DeleteScreenSuccess = function(Response, textStatus, jqXHR) {
		for (var key in this._DeleteScreenSuccessListeners) {
			this._DeleteScreenSuccessListeners[key](Response, textStatus, jqXHR);
		}
	};

	ScreenerUtility.fn._DeleteScreenFailure = function(jqXHR, textStatus, errorThrown) {
		for (var key in this._DeleteScreenFailureListeners) {
			this._DeleteScreenFailureListeners[key](jqXHR, textStatus, errorThrown);
		}
	};

	/************************************
	*
	* [End] Send Data Methods
	*
	************************************/

	ScreenerUtility.fn.DoSetDefaultScreen = function(type, name) {
		var context = this;

		this._BeforeSetDefaultScreen();

		var DataToSend = {
			Type: type,
			Name: name
		};

		$.ajax({
			type: "POST",
			data: DataToSend,
			dataType: "json",
			url: this._SetDefaultScreenURL.resolveUrl(),
			complete: function(jqXHR, textStatus) { context._SetDefaultScreenComplete(jqXHR, textStatus); },
			success: function(Response, textStatus, jqXHR) { context._SetDefaultScreenSuccess(Response, textStatus, jqXHR); },
			error: function(jqXHR, textStatus, errorThrown) { context._SetDefaultScreenFailure(jqXHR, textStatus, errorThrown); }
		});
	};

	/************************************
	*
	* [Start] Send Data Methods
	*
	************************************/

	ScreenerUtility.fn._BeforeSetDefaultScreen = function() {
		for (var key in this._BeforeSetDefaultScreenListeners) {
			this._BeforeSetDefaultScreenListeners[key]();
		}
	};

	ScreenerUtility.fn._SetDefaultScreenComplete = function(jqXHR, textStatus) {
		for (var key in this._SetDefaultScreenCompleteListeners) {
			this._SetDefaultScreenCompleteListeners[key](jqXHR, textStatus);
		}
	};

	ScreenerUtility.fn._SetDefaultScreenSuccess = function(Response, textStatus, jqXHR) {
		for (var key in this._SetDefaultScreenSuccessListeners) {
			this._SetDefaultScreenSuccessListeners[key](Response, textStatus, jqXHR);
		}
	};

	ScreenerUtility.fn._SetDefaultScreenFailure = function(jqXHR, textStatus, errorThrown) {
		for (var key in this._SetDefaultScreenFailureListeners) {
			this._SetDefaultScreenFailureListeners[key](jqXHR, textStatus, errorThrown);
		}
	};

	/************************************
	*
	* [End] Send Data Methods
	*
	************************************/

	// Create default instance of the screener utility
	Namespace.ScreenerUtility = ScreenerUtility;

	Namespace.ScreenerUtility.Instance = Namespace.ScreenerUtility.CreateInstance();

	/********************************************
	*
	* End - ScreenerUtility
	*
	********************************************/

})(window.MOD || window.WSOD || window);